module.exports = __webpack_public_path__ + "static/media/garbage.03980f20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/garbage.svg
// module id = 268
// module chunks = 0